import React, {  useState, useEffect, useRef } from 'react';


import { Button } from '@shadcn/components/ui/button';
import { Row } from '@shadcn/components/ui/row';
import { Card, CardContent as CardBody, CardHeader } from '@shadcn/components/ui/card';
import { Col } from '@shadcn/components/ui/col';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import useQuery from '../../../helpers/JIFI/useQuery';
import superagent from 'superagent'
import { backendUrl } from '../../../helpers/consts.js'
import ProductVariantSelector from '../helpers/ProductVariantSelector.js';
import { CustomInput } from '../purchase-orders';
import { Input } from '@shadcn/components/ui/input';
import SupplyChainNav from '@components/supply-chain/nav';

const generateID = () => {
  return `PARCEl-${Math.trunc(Math.random() * 1000 + 1)}_${Math.trunc(Math.random() * 1000 + 1)}`
}

const ParcelLine = ({ products, parcel, remove, refresh }) => {
  const [productId, setProductId] = useState(parcel.productId)
  const [description, setDescription] = useState(parcel.description)
  const [price, setPrice] = useState(parcel.price)
  const [length, setLength] = useState(parcel.length)
  const [width, setWidth] = useState(parcel.width)
  const [depth, setDepth] = useState(parcel.depth)
  const [weight, setWeight] = useState(parcel.weight)

  let modified = (
    productId !== parcel.productId ||
    description !== parcel.description ||
    price !== parcel.price ||
    length !== parcel.length ||
    width !== parcel.width ||
    depth !== parcel.depth ||
    weight !== parcel.weight
  )

  useEffect(() => {
    if (!modified) {
      setProductId(parcel.productId)
      setDescription(parcel.description)
      setPrice(parcel.price)
      setLength(parcel.length)
      setWidth(parcel.width)
      setDepth(parcel.depth)
      setWeight(parcel.weight)
    }
  }, [parcel])

  const handleSave = () => {
    if (parcel.new === true) {
      superagent.post(`${backendUrl}/orders/createParcel/`)
        .send({
          product: productId,
          parcel_description: description,
          declared_price: Number(price),
          length: Number(length),
          width: Number(width),
          depth: Number(depth),
          weight: Number(weight)
        })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .on('error', (response) => {
          console.log(response)
        })
        .then(response => {
          const code = response.status
          if (code > 400) {
          } else {
            refresh()
          }
        }).catch(err => {
          console.log(err)
        });
    } else {
      superagent.post(`${backendUrl}/orders/editParcel/${parcel._id}/`)
        .send({
          product: productId,
          parcel_description: description,
          declared_price: Number(price),
          length: Number(length),
          width: Number(width),
          depth: Number(depth),
          weight: Number(weight)
        })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .on('error', (response) => {
          console.log(response)
        })
        .then(response => {
          const code = response.status
          if (code > 400) {
          } else {
            refresh()
          }
        }).catch(err => {
          console.log(err)
        });

    }
  }

  const handleDelete = () => {
    if (parcel.new === true) {
      remove()
    } else {
      superagent.post(`${backendUrl}/orders/deleteParcel/${parcel._id}/`)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .on('error', (response) => {
          console.log(response)
        })
        .then(response => {
          const code = response.status
          if (code > 400) {
          } else {
            refresh()
          }
        }).catch(err => {
          console.log(err)
        });
    }
  }

  const volume = parseFloat(((length / 100 * width / 100 * depth / 100) || 0)).toFixed(4);
  console.log("current product id", productId)
  return (
    <>
      <tr>
        <th scope="row">
          <ProductVariantSelector products={products} setSelectedProduct={setProductId} selectedProduct={productId} />
        </th>
        <th scope="row">
          <Input placeholder="Description" className="mb-2" type="text" value={description} onChange={(e) => { setDescription(e.target.value) }} />
        </th>
        <th scope="row">
          <CustomInput value={price} onChange={(e) => setPrice(e.target.value)} isPrefix={true} preSufix="$" />
        
        </th>
        <th scope="row">
          <CustomInput value={length} onChange={(e) => setLength(e.target.value)}  preSufix="Cm" />
        
        </th>
        <th scope="row">
          <CustomInput value={width} onChange={(e) => setWidth(e.target.value)}  preSufix="Cm" />
      
        </th>
        <th scope="row">
          <CustomInput value={depth} onChange={(e) => setDepth(e.target.value)}  preSufix="Cm" />
       
        </th>
        <th scope="row">
          <CustomInput type='text' value={volume} disabled={true} preSufix="m3" />
          
        </th>
        <th scope="row">
          <CustomInput value={weight} onChange={(e) => setWeight(e.target.value)}  preSufix="Kg" />
        
        </th>
        <th scopr="row">
          {
            (modified || parcel.new === true) && <i style={{ fontSize: '32px', cursor: 'pointer' }} onClick={handleSave} className="bx bx-save text-success" />
          }
        </th>
        <th scopr="row">
          <i style={{ fontSize: '32px', cursor: 'pointer' }} onClick={handleDelete} className="bx bx-trash-alt text-danger" />
        </th>
      </tr>
    </>
  )
}

const ParcelsPage = () => {
  const [refresh, setRefresh] = useState(false)
  const r = () => setRefresh(prev => !prev)
  const [parcels, setParcels] = useState([])
  const csvFileInputRef = useRef(null)
  const [importReport, setImportReport] = useState(null)
  const [isExportingCsv, setIsExportingCsv] = useState(false)
  const [isImportingCsv, setIsImportingCsv] = useState(false)

  const [dataProduct, stateProduct] = useQuery({
    url: `/product`,
    refresh
  });
  const [dataParcel, stateParcel] = useQuery({
    url: `/orders/fetchAllParcels`,
    refresh
  });
  const products = dataProduct && dataProduct.data
  useEffect(() => {
    if (dataParcel) {
      setParcels(dataParcel.map(val => ({
        _id: val._id,
        productId: val?.product?._id,
        description: val.parcel_description,
        price: val.declared_price,
        length: val.length,
        width: val.width,
        depth: val.depth,
        weight: val.weight,
        sortVolumetric: val.length * val.width * val.depth
      })).sort((a, b) => a.sortVolumetric - b.sortVolumetric))
    }
  }, [dataParcel])

  const handleRemove = (removeKey) => {
    setParcels(prev => {
      let updatedParcels = [...prev]
      return updatedParcels.filter((value, key) => removeKey !== key)
    })
  }

  const loading = stateParcel === 'loading' || stateProduct === 'loading'

  const getInitParcel = () => {
    return {
      productId: products[0]._id,
      description: '',
      price: 0,
      length: 0,
      width: 0,
      depth: 0,
      weight: 0,
      new: true
    }
  }

  const createNewParcel = () => {
    setParcels(prev => {
      let updatedParcels = [...prev]
      updatedParcels.push(getInitParcel())
      return updatedParcels
    })
  }

  const handleExportCsv = () => {
    if (isExportingCsv) return
    setIsExportingCsv(true)
    superagent
      .get(`${backendUrl}/orders/exportParcelsCsv`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .responseType('blob')
      .then(response => {
        const blob = new Blob([response.body], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'parcels-export.csv'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      })
      .catch(err => {
        console.error('Export CSV failed', err)
        alert('Failed to export parcel CSV')
      })
      .finally(() => setIsExportingCsv(false))
  }

  const handleImportCsvFile = (e) => {
    const file = e.target.files && e.target.files[0]
    e.target.value = ''
    if (!file) return
    setIsImportingCsv(true)
    superagent
      .post(`${backendUrl}/orders/importParcelsCsv`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .attach('file', file)
      .then(response => {
        const report = response.body
        setImportReport(report)
        setParcels([])
        r()
        const { updatedRows, errorRows, skippedRows } = report
        if (errorRows > 0) {
          alert(`Import finished: ${updatedRows} updated, ${errorRows} errors, ${skippedRows} skipped`)
        } else {
          alert(`Import finished: ${updatedRows} updated, ${skippedRows} skipped`)
        }
      })
      .catch(err => {
        console.error('Import CSV failed', err)
        alert('Failed to import parcel CSV')
      })
      .finally(() => setIsImportingCsv(false))
  }

  return (
    <>
    <SupplyChainNav menuType="products">
      <input
        ref={csvFileInputRef}
        type="file"
        accept=".csv,text/csv"
        style={{ display: 'none' }}
        onChange={handleImportCsvFile}
      />
      <div>
          <Row>
            <Col className="w-full">
              <Card className='mb-6'>
                <CardHeader>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h4 className="card-title mb-4"></h4>
                    <Row className='flex flex-1 justify-between items-center'>
                      <Breadcrumbs title="Setting" breadcrumbItem="Parcels" />
                      {
                        loading === false && (
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <Button variant="outline" disabled={isExportingCsv} onClick={handleExportCsv}>
                              {isExportingCsv ? 'Exporting...' : 'Export CSV'}
                            </Button>
                            <Button variant="outline" disabled={isImportingCsv} onClick={() => csvFileInputRef.current && csvFileInputRef.current.click()}>
                              {isImportingCsv ? 'Importing...' : 'Import CSV'}
                            </Button>
                            <Button variant="success" onClick={createNewParcel}> Create </Button>
                          </div>
                        )
                      }
                    </Row>
                  </div>
                  {
                    importReport && (
                      <div style={{ marginTop: '8px', padding: '8px', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px', fontSize: '13px' }}>
                        <strong>Last import:</strong> Total {importReport.totalRows} · Updated {importReport.updatedRows} · Errors {importReport.errorRows} · Skipped {importReport.skippedRows}
                        {importReport.rows.filter(r => r.status === 'error' || (r.warnings && r.warnings.length > 0)).length > 0 && (
                          <ul style={{ marginTop: '6px', marginBottom: 0, paddingLeft: '16px' }}>
                            {importReport.rows
                              .filter(r => r.status === 'error' || (r.warnings && r.warnings.length > 0))
                              .map((r, i) => (
                                <li key={i} style={{ color: r.status === 'error' ? '#dc3545' : '#856404' }}>
                                  Row {r.row}{r.parcelId ? ` · ${r.parcelId}` : ''}: {r.message || (r.warnings && r.warnings.join('; '))}
                                </li>
                              ))
                            }
                          </ul>
                        )}
                      </div>
                    )
                  }
                </CardHeader>
                <CardBody>
                  {
                    loading === false ? (
                      <table className="table mb-0">
                        <thead style={{ position: 'sticky', top: 123, background: 'white', }}>
                          <tr>
                            <th>Product</th>
                            <th>Description</th>
                            <th>Declared Price</th>
                            <th>Length</th>
                            <th>Width</th>
                            <th>Depth</th>
                            <th>Volume</th>
                            <th>Weight</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            parcels.map((parcel, key) => <ParcelLine refresh={() => { setParcels([]); r(); }} remove={() => handleRemove(key)} parcel={parcel} products={products} />)
                          }
                        </tbody>
                      </table>
                    ) : (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="spinner-border text-primary m-1" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    )
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </SupplyChainNav>
    </>
  )
}

export default ParcelsPage
